import { TYPE_STRING } from './input-types';

export const id = 'returningParty';
export const apiKey = 'returnFromName';
export const type = TYPE_STRING;

export const returningParty = {
  id,
  apiKey,
  type,
};
